import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(trackMoreAvailabilitySuccess),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(trackMoreAvailabilityFailure),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(trackDidYouMean),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(trackAvailabilitySuccess),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(trackAvailabilityFailure),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(trackClickQuit),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(trackClickStoreDetails),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(trackClickSelectStore),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(trackClickWantItDelivered),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(trackClickFilter),
    _marked11 = /*#__PURE__*/_regeneratorRuntime.mark(watchMoreAvailabilitySuccess),
    _marked12 = /*#__PURE__*/_regeneratorRuntime.mark(watchMoreAvailabilityFailure),
    _marked13 = /*#__PURE__*/_regeneratorRuntime.mark(watchDidYouMean),
    _marked14 = /*#__PURE__*/_regeneratorRuntime.mark(watchAvailabilitySuccess),
    _marked15 = /*#__PURE__*/_regeneratorRuntime.mark(watchAvailabilityFailure),
    _marked16 = /*#__PURE__*/_regeneratorRuntime.mark(watchClickQuit),
    _marked17 = /*#__PURE__*/_regeneratorRuntime.mark(watchClickStoreDetails),
    _marked18 = /*#__PURE__*/_regeneratorRuntime.mark(watchClickSelectStore),
    _marked19 = /*#__PURE__*/_regeneratorRuntime.mark(watchClickWantItDelivered),
    _marked20 = /*#__PURE__*/_regeneratorRuntime.mark(watchClickFilter);

import { takeEvery, select, call } from 'redux-saga/effects';
import { hasAvailabilityCheck, filterAvailability, formatAvailabilityForAnalytics, showMoreAvailability } from '../helpers/storeHelpers';
import { FETCH_MORE_AVAILABILITY_SUCCESS, FETCH_AVAILABILITY_FAILURE, FETCH_AVAILABILITY_DID_YOU_MEAN, FETCH_AVAILABILITY_SUCCESS, FETCH_MORE_AVAILABILITY_FAILURE, TRACK_CLICK_QUIT, TRACK_CLICK_STORE_DETAILS, TRACK_CLICK_SELECT_STORE, TRACK_CLICK_WANT_IT_DELIVERED, TRACK_CLICK_FILTER } from '../actions/types';
import { doTrack, doTrackClick } from '../helpers/TaggingSerializer';
var gpsPattern = /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/;
/* Sagas */

function trackMoreAvailabilitySuccess(_ref) {
  var payload, state, storeId, eventName, event;
  return _regeneratorRuntime.wrap(function trackMoreAvailabilitySuccess$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          _context.next = 3;
          return select();

        case 3:
          state = _context.sent;
          storeId = payload && payload.stores && payload.stores.length && payload.stores[0].store_id || '';
          eventName = "".concat(state.storeSelectorTracking.code, "_storeSelectorTellMeWhere");
          event = {
            attributes: {
              tellMeWhere: "available:".concat(storeId)
            },
            eventInfo: {
              eventName: eventName,
              eventAction: "".concat(state.storeSelectorTracking.code, " Store Selector Tell Me Where")
            }
          };
          _context.next = 9;
          return call(doTrackClick, eventName, event);

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function trackMoreAvailabilityFailure() {
  var state, eventName, event;
  return _regeneratorRuntime.wrap(function trackMoreAvailabilityFailure$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select();

        case 2:
          state = _context2.sent;
          eventName = "".concat(state.storeSelectorTracking.code, "_storeSelectorTellMeWhere");
          event = {
            attributes: {
              tellMeWhere: 'notAvailable'
            },
            eventInfo: {
              eventName: eventName,
              eventAction: "".concat(state.storeSelectorTracking.code, " Store Selector Tell Me Where")
            }
          };
          _context2.next = 7;
          return call(doTrackClick, eventName, event);

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function trackDidYouMean() {
  var state, pageName, eventName, attributes;
  return _regeneratorRuntime.wrap(function trackDidYouMean$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select();

        case 2:
          state = _context3.sent;
          pageName = "ar:".concat(state.storeSelectorTracking.section, ":storeSelector:locationsList");
          eventName = "".concat(state.storeSelectorTracking.code, "_storeSelectorLocationsListPage");
          attributes = {
            searchBoxWasUsed: state.storeSelectorTracking.searchBoxWasUsed,
            searchBoxValue: state.storeSelectorTracking.searchBoxValue
          };
          _context3.next = 8;
          return call(doTrack, pageName, eventName, attributes);

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function trackAvailabilitySuccess() {
  var state, storeSelectorTracking, storeSelectorAvailability, section, code, searchBoxValue, searchBoxWasUsed, apiSearchValue, tellMeWhereEnabled, refinement, refinementBoxWasUsed, skuQty, filteredAvailability, formattedAvailability, pageName, eventName, attributes;
  return _regeneratorRuntime.wrap(function trackAvailabilitySuccess$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return select();

        case 2:
          state = _context4.sent;
          storeSelectorTracking = state.storeSelectorTracking, storeSelectorAvailability = state.storeSelectorAvailability;
          section = storeSelectorTracking.section, code = storeSelectorTracking.code, searchBoxValue = storeSelectorTracking.searchBoxValue, searchBoxWasUsed = storeSelectorTracking.searchBoxWasUsed, apiSearchValue = storeSelectorTracking.apiSearchValue, tellMeWhereEnabled = storeSelectorTracking.tellMeWhereEnabled, refinement = storeSelectorTracking.refinement, refinementBoxWasUsed = storeSelectorTracking.refinementBoxWasUsed, skuQty = storeSelectorTracking.skuQty;
          filteredAvailability = filterAvailability(storeSelectorAvailability.availability, refinement);
          formattedAvailability = filteredAvailability.map(formatAvailabilityForAnalytics);
          pageName = "ar:".concat(section, ":storeSelector:storesList");
          eventName = "".concat(code, "_storeSelectorStoresListPage");
          attributes = {
            searchBoxValue: searchBoxValue,
            searchBoxWasUsed: searchBoxWasUsed,
            apiSearchValue: apiSearchValue,
            apiSearchType: apiSearchValue === null || apiSearchValue.match(gpsPattern) === null ? 'location' : 'coordinates',
            refinement: refinement.label,
            refinementBoxWasUsed: refinementBoxWasUsed,
            tellMeWhere: showMoreAvailability(tellMeWhereEnabled, hasAvailabilityCheck(state.storeSelectorAvailability.availability), state.storeSelectorAvailability.safeMode, skuQty) ? 'offered' : 'notOffered',
            store: formattedAvailability
          };
          _context4.next = 12;
          return call(doTrack, pageName, eventName, attributes);

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function trackAvailabilityFailure() {
  var state, pageName, eventName, attributes;
  return _regeneratorRuntime.wrap(function trackAvailabilityFailure$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return select();

        case 2:
          state = _context5.sent;
          pageName = "ar:".concat(state.storeSelectorTracking.section, ":storeSelector:searchError:");
          eventName = "".concat(state.storeSelectorTracking.code, "_storeSelectorSearchErrorPage");
          attributes = {
            searchBoxWasUsed: state.storeSelectorTracking.searchBoxWasUsed,
            searchBoxValue: state.storeSelectorTracking.searchBoxValue
          };
          _context5.next = 8;
          return call(doTrack, pageName, eventName, attributes);

        case 8:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function trackClickQuit() {
  var state, eventName, event;
  return _regeneratorRuntime.wrap(function trackClickQuit$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return select();

        case 2:
          state = _context6.sent;
          eventName = "".concat(state.storeSelectorTracking.code, "_storeSelectorClosed");
          event = {
            eventInfo: {
              eventName: eventName,
              eventAction: "".concat(state.storeSelectorTracking.code, " Store Selector Closed")
            }
          };
          _context6.next = 7;
          return call(doTrackClick, eventName, event);

        case 7:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function trackClickStoreDetails(_ref2) {
  var storeId, state, eventName, event;
  return _regeneratorRuntime.wrap(function trackClickStoreDetails$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          storeId = _ref2.storeId;
          _context7.next = 3;
          return select();

        case 3:
          state = _context7.sent;
          eventName = "".concat(state.storeSelectorTracking.code, "_storeSelectorShowStoreDetails");
          event = {
            attributes: {
              store: storeId
            },
            eventInfo: {
              eventName: eventName,
              eventAction: "".concat(state.storeSelectorTracking.code, " Store Selector Show Store Details")
            }
          };
          _context7.next = 8;
          return call(doTrackClick, eventName, event);

        case 8:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function trackClickSelectStore(_ref3) {
  var storeId, ctaLocation, state, eventName, event;
  return _regeneratorRuntime.wrap(function trackClickSelectStore$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          storeId = _ref3.storeId, ctaLocation = _ref3.ctaLocation;
          _context8.next = 3;
          return select();

        case 3:
          state = _context8.sent;
          eventName = "".concat(state.storeSelectorTracking.code, "_storeSelectorSelectThisStore");
          event = {
            attributes: {
              ctaLocation: ctaLocation,
              store: storeId
            },
            eventInfo: {
              eventName: eventName,
              eventAction: "".concat(state.storeSelectorTracking.code, " Store Selector Select This Store")
            }
          };
          _context8.next = 8;
          return call(doTrackClick, eventName, event);

        case 8:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function trackClickWantItDelivered() {
  var state, eventName, event;
  return _regeneratorRuntime.wrap(function trackClickWantItDelivered$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return select();

        case 2:
          state = _context9.sent;
          eventName = "".concat(state.storeSelectorTracking.code, "_storeSelectorWantItDelivered");
          event = {
            eventInfo: {
              eventName: eventName,
              eventAction: "".concat(state.storeSelectorTracking.code, " Store Selector Select This Store")
            }
          };
          _context9.next = 7;
          return call(doTrackClick, eventName, event);

        case 7:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function trackClickFilter() {
  var state, storeSelectorTracking, storeSelectorAvailability, section, code, searchBoxValue, searchBoxWasUsed, apiSearchValue, tellMeWhereEnabled, refinement, refinementBoxWasUsed, skuQty, filteredAvailability, formattedAvailability, pageName, eventName, attributes;
  return _regeneratorRuntime.wrap(function trackClickFilter$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return select();

        case 2:
          state = _context10.sent;
          storeSelectorTracking = state.storeSelectorTracking, storeSelectorAvailability = state.storeSelectorAvailability;
          section = storeSelectorTracking.section, code = storeSelectorTracking.code, searchBoxValue = storeSelectorTracking.searchBoxValue, searchBoxWasUsed = storeSelectorTracking.searchBoxWasUsed, apiSearchValue = storeSelectorTracking.apiSearchValue, tellMeWhereEnabled = storeSelectorTracking.tellMeWhereEnabled, refinement = storeSelectorTracking.refinement, refinementBoxWasUsed = storeSelectorTracking.refinementBoxWasUsed, skuQty = storeSelectorTracking.skuQty;
          filteredAvailability = filterAvailability(storeSelectorAvailability.availability, refinement);
          formattedAvailability = filteredAvailability.map(formatAvailabilityForAnalytics);
          pageName = "ar:".concat(section, ":storeSelector:storesList");
          eventName = "".concat(code, "_storeSelectorStoresListPage");
          attributes = {
            searchBoxValue: searchBoxValue,
            searchBoxWasUsed: searchBoxWasUsed,
            apiSearchValue: apiSearchValue,
            apiSearchType: apiSearchValue === null || apiSearchValue.match(gpsPattern) === null ? 'location' : 'coordinates',
            refinement: refinement.label,
            refinementBoxWasUsed: refinementBoxWasUsed,
            tellMeWhere: showMoreAvailability(tellMeWhereEnabled, hasAvailabilityCheck(state.storeSelectorAvailability.availability), state.storeSelectorAvailability.safeMode, skuQty) ? 'offered' : 'notOffered',
            store: formattedAvailability
          };
          _context10.next = 12;
          return call(doTrack, pageName, eventName, attributes);

        case 12:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}
/* Watchers */


export function watchMoreAvailabilitySuccess() {
  return _regeneratorRuntime.wrap(function watchMoreAvailabilitySuccess$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return takeEvery(FETCH_MORE_AVAILABILITY_SUCCESS, trackMoreAvailabilitySuccess);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}
export function watchMoreAvailabilityFailure() {
  return _regeneratorRuntime.wrap(function watchMoreAvailabilityFailure$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return takeEvery(FETCH_MORE_AVAILABILITY_FAILURE, trackMoreAvailabilityFailure);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}
export function watchDidYouMean() {
  return _regeneratorRuntime.wrap(function watchDidYouMean$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return takeEvery(FETCH_AVAILABILITY_DID_YOU_MEAN, trackDidYouMean);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}
export function watchAvailabilitySuccess() {
  return _regeneratorRuntime.wrap(function watchAvailabilitySuccess$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return takeEvery(FETCH_AVAILABILITY_SUCCESS, trackAvailabilitySuccess);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}
export function watchAvailabilityFailure() {
  return _regeneratorRuntime.wrap(function watchAvailabilityFailure$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return takeEvery(FETCH_AVAILABILITY_FAILURE, trackAvailabilityFailure);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}
export function watchClickQuit() {
  return _regeneratorRuntime.wrap(function watchClickQuit$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return takeEvery(TRACK_CLICK_QUIT, trackClickQuit);

        case 2:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked16);
}
export function watchClickStoreDetails() {
  return _regeneratorRuntime.wrap(function watchClickStoreDetails$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return takeEvery(TRACK_CLICK_STORE_DETAILS, trackClickStoreDetails);

        case 2:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked17);
}
export function watchClickSelectStore() {
  return _regeneratorRuntime.wrap(function watchClickSelectStore$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return takeEvery(TRACK_CLICK_SELECT_STORE, trackClickSelectStore);

        case 2:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked18);
}
export function watchClickWantItDelivered() {
  return _regeneratorRuntime.wrap(function watchClickWantItDelivered$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return takeEvery(TRACK_CLICK_WANT_IT_DELIVERED, trackClickWantItDelivered);

        case 2:
        case "end":
          return _context19.stop();
      }
    }
  }, _marked19);
}
export function watchClickFilter() {
  return _regeneratorRuntime.wrap(function watchClickFilter$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return takeEvery(TRACK_CLICK_FILTER, trackClickFilter);

        case 2:
        case "end":
          return _context20.stop();
      }
    }
  }, _marked20);
}